import ui from './src/ui';
import utils from './src/utils';
import mixins from './src/mixins';
import tracking from './src/tracking';

import createCustomElement from './src/wrapper/custom-element';

if (!window.__DISABLE_MDS_ICON__) {
    utils.loadSVGIcons();
}
export default {
    ui,
    utils,
    mixins,
    tracking,
    createCustomElement
};
